import _regeneratorRuntime from "@babel/runtime/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import LoadScript from 'react-load-script';
import React from 'react';
import { appleWebPay } from '../../../../util';
import * as UTIL from '../../../../util';

var ApplePayComponent = function ApplePayComponent(props) {
  var disableButton = false;
  var session = null;
  var paymentRequest = null;

  var onApplePaymentButtonClicked = function onApplePaymentButtonClicked() {
    var data = JSON.parse(window.localStorage.getItem('digitalWalletValues'));

    if (!disableButton) {
      _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var validate;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                disableButton = true;
                _context2.prev = 1;
                props.placeOrderClick();
                _context2.next = 5;
                return props.validateForm();

              case 5:
                validate = _context2.sent;

                if (!(Object.keys(validate).length > 0)) {
                  _context2.next = 10;
                  break;
                }

                Object.keys(validate).forEach(function (key) {
                  props.setFieldTouched(key, true);
                });
                disableButton = false;
                return _context2.abrupt("return");

              case 10:
                // Create a payment request
                paymentRequest = {
                  countryCode: 'US',
                  merchantId: appleWebPay.merchantId,
                  currencyCode: 'USD',
                  total: {
                    label: 'Cracker Barrel',
                    amount: data.total.toFixed(2),
                    type: 'final'
                  },
                  requiredBillingContactFields: ['postalAddress'],
                  supportedNetworks: ['amex', 'masterCard', 'visa', 'discover'],
                  // Supported card networks
                  merchantCapabilities: ['supports3DS', 'supportsCredit', 'supportsDebit'] // Merchant capabilities

                };
                window.localStorage.setItem('validateCart', false);
                props.submitForm().then(function (response) {
                  if (!response) {
                    window.localStorage.setItem('validateCart', false);
                    disableButton = false;
                  } else {
                    window.localStorage.setItem('validateCart', true);
                  }
                }); // Create a new Apple Pay session

                session = new ApplePaySession(3, paymentRequest);

                session.onvalidatemerchant = function (event) {
                  // Validate the merchant with your server (not implemented here)
                  // You would typically make a server request to validate the merchant
                  // Use the event.validationURL to send a validation request
                  _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
                    var validationURL, merchantIdentifier, requestData, response, merchantSession, _session;

                    return _regeneratorRuntime.wrap(function _callee$(_context) {
                      while (1) {
                        switch (_context.prev = _context.next) {
                          case 0:
                            _context.prev = 0;
                            validationURL = event.validationURL;
                            merchantIdentifier = appleWebPay.merchantId;
                            requestData = {
                              validationURL: validationURL,
                              merchantIdentifer: merchantIdentifier,
                              domain: window.location.hostname
                            }; // Make a POST request to your server

                            _context.next = 6;
                            return fetch(UTIL.apiUtil.generateUrl('applepay', 'merchantValidation'), {
                              method: 'POST',
                              headers: UTIL.apiUtil.setHeaders(),
                              body: JSON.stringify(requestData)
                            });

                          case 6:
                            response = _context.sent;

                            if (response.ok) {
                              _context.next = 9;
                              break;
                            }

                            throw new Error('Network response was not ok');

                          case 9:
                            _context.next = 11;
                            return response.json();

                          case 11:
                            merchantSession = _context.sent;
                            // Complete merchant validation
                            session.completeMerchantValidation(merchantSession);
                            _context.next = 20;
                            break;

                          case 15:
                            _context.prev = 15;
                            _context.t0 = _context["catch"](0);
                            disableButton = false;
                            console.error('Failed to validate merchant:', _context.t0);
                            (_session = session) === null || _session === void 0 ? void 0 : _session.abort();

                          case 20:
                          case "end":
                            return _context.stop();
                        }
                      }
                    }, _callee, null, [[0, 15]]);
                  }))();
                };

                session.onpaymentauthorized = function (event) {
                  // Handle the payment authorization here
                  // Payment token structure example

                  /*{
                    "paymentData": {
                      "data": "MVS4JnER36r0s5c7HN/KPj/xV+yOPGoqil2Savtdcxl+4iLZp0jMqZIEOoQ/wjo5pyjgf3NHk9g7092jdR29x6PR+yeakHLgiC6PNzRHf8elkAaxBQ2wD1w1X81Ve/UA3Mw63clX166O9AwrlkvhRV9d8JOvV+DALfrDmCcjJ07h+BBuQBQbdJAEl7lKcFTQj+Qy8+pKqpQ5ypEV2hYq58FkwP4k6KU41Z0MQi/yV9g0npUVvAnmP+P7Ulo0pulq3GDvGGr2VlekWQX/iNI8DG8FFZsOv4f1R35ebaoFKVYenKvB713wH1RLNn5+BP0Z67bPs7260r9j9Os0OSMqTBZZItEiLXNFLK/S8idcUwU6CjOcquuP9DGaXMmFKqk3O7cVMnhBl3XEAKqn",
                      "signature": "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",
                      "header": {
                        "publicKeyHash": "DUk3mLvfQgqZFWz9r45AsSC7Ew7mcDnbyChqPVfSG3c=",
                        "ephemeralPublicKey": "MFkwEwYHKoZIzj0CAQYIKoZIzj0DAQcDQgAEGhSiCMVgPn6hwM8IejSlpgzdSOnfdHDQHtnNF7iVM8RXHT9YzTUS/hWFVJk31GU0WukjNpI3Vfm/4OgMoVFwjA==",
                        "transactionId": "99c83d34a322b04642ea0031c782e45ab81e415bc2b94f0e1f0c5d3758a112ad"
                      },
                      "version": "EC_v1"
                    },
                    "paymentMethod": {
                      "displayName": "MasterCard 8095",
                      "network": "MasterCard",
                      "type": "credit"
                    },
                    "transactionIdentifier": "99C83D34A322B04642EA0031C782E45AB81E415BC2B94F0E1F0C5D3758A112AD"
                  }*/
                  var validateCart = window.localStorage.getItem('validateCart');

                  if (!validateCart || validateCart === 'false') {
                    console.info('Transaction canceled due a cart validation fail');
                    disableButton = false;
                    session.abort();
                    return;
                  }

                  var paymentInfo = event.payment;
                  props.handleSubmitCart(data.values, paymentInfo).then(function (response) {
                    // Process the response from your server
                    if (response === true) {
                      // Notify Apple Pay session that the payment was successful
                      session.completePayment({
                        status: ApplePaySession.STATUS_SUCCESS
                      });
                    } else {
                      // Notify Apple Pay session that the payment failed
                      session.completePayment({
                        status: ApplePaySession.STATUS_FAILURE
                      });
                    }

                    disableButton = false;
                  });
                }; // Handle errors and session completion


                session.oncancel = function (event) {
                  console.info('Apple Pay session canceled:', event);

                  if (event.status === ApplePaySession.STATUS_FAILURE) {
                    console.error('Apple Pay session canceled:', event.reason);
                  } else {
                    console.info('Apple Pay session completed without payment.');
                  }

                  disableButton = false;
                }; // Start the Apple Pay session when the button is clicked


                session.begin();
                _context2.next = 24;
                break;

              case 20:
                _context2.prev = 20;
                _context2.t0 = _context2["catch"](1);
                disableButton = false;
                console.error('Error on Apple Pay Flow:', _context2.t0);

              case 24:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, null, [[1, 20]]);
      }))();
    }
  };

  var onApplePayLoaded = function onApplePayLoaded() {
    // Define the Apple Pay button
    var applePayButton = document.getElementById('applePayButton'); // Check if the browser supports Apple Pay

    if (window.ApplePaySession) {
      // Attach the Apple Pay button to the DOM
      applePayButton.addEventListener('click', onApplePaymentButtonClicked);
    }
  };

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(LoadScript, {
    url: "https://applepay.cdn-apple.com/jsapi/v1.1.0/apple-pay-sdk.js",
    onLoad: function onLoad() {
      onApplePayLoaded();
    }
  }), /*#__PURE__*/React.createElement("apple-pay-button", {
    id: "applePayButton",
    buttonstyle: "black",
    type: "plain",
    locale: "en-US"
  }));
};

export { ApplePayComponent };